<script setup lang="ts">
import ClientWorkspaceDetail from '~/components/clients/ClientWorkspaceDetail.vue';
import { resolveWorkspaceDetailHeaderPresentation } from '~/lib/workspacePresentation';

definePageMeta({
    layout: 'app',
    middleware: ['tenant'],
});

const route = useRoute();
const tenantStore = useTenantStore();
const clientSlug = computed(() => String(route.params.slug || '').trim());
const headerPresentation = computed(() => resolveWorkspaceDetailHeaderPresentation(tenantStore.currentTenant));

usePageShellPresentation(computed(() => headerPresentation.value === 'immersive' ? 'immersive' : 'default'));
</script>

<template>
    <ClientWorkspaceDetail :client-slug="clientSlug" :header-presentation="headerPresentation" />
</template>
